import React, { useContext, useState } from "react";
import Style from "./index.module.scss";
import { Alert, Button, Dropdown, Menu, Spin } from "antd";
import { CourseContext } from "../Store";
import useBatchPicker from "../../main/utils/useBatchPicker";
import useRequest from "../../../Utils/useRequest";
import { ActStatusType, queryMyGroupActivityList } from "../../../API/teams";
import ListItem from "./Components/ListItem";
import CustomEmpty from "../../../components/CustomEmpty";
import useDeviceType from "../../../Utils/useDeviceType";
import { useHistory } from "react-router-dom";

const Index = () => {
    const { isPC, isMobile } = useDeviceType();
    const history = useHistory();
    const { basename, course } = useContext(CourseContext);
    const { batch } = useBatchPicker();
    const baseParams = {
        batchNo: batch,
        weektimeId: course.weekTimeId,
        courseNo: course.courseNo,
        courseSeq: course.courseSeq
    };

    const [statusQuery, setStatusQuery] = useState<ActStatusType>(
        ActStatusType.All
    );

    const [data, { loading }] = useRequest(
        () =>
            queryMyGroupActivityList({
                ...baseParams,
                statusQuery
            }),
        {},
        [statusQuery]
    );

    const menu = (
        <Menu>
            <Menu.Item onClick={() => setStatusQuery(ActStatusType.All)}>
                <div>全部</div>
            </Menu.Item>
            <Menu.Item
                onClick={() => setStatusQuery(ActStatusType.ToBeInvolved)}>
                <div>待参与</div>
            </Menu.Item>
            <Menu.Item
                onClick={() => setStatusQuery(ActStatusType.ToBeSubmitted)}>
                <div>待提交</div>
            </Menu.Item>
            <Menu.Item onClick={() => setStatusQuery(ActStatusType.Submitted)}>
                <div>已参加</div>
            </Menu.Item>
        </Menu>
    );

    return (
        <div>
            {isMobile && (
                <Alert
                    style={{
                        borderRadius: 0,
                        marginBottom: 15
                    }}
                    message="手机端不支持参与活动，请到pc端提交作业。"
                    type="warning"
                />
            )}
            <div className={Style.nav}>
                <span>小组活动 ({data?.length})</span>
                <div className={Style.rightNav}>
                    {isPC && (
                        <Dropdown overlay={menu} placement="bottomCenter">
                            <Button
                                icon="filter"
                                type="link"
                                size={isPC ? "default" : "small"}>
                                筛选
                            </Button>
                        </Dropdown>
                    )}
                    <Button
                        icon="team"
                        type="link"
                        onClick={() => history.push("teams/my")}
                        size={isPC ? "default" : "small"}>
                        我的小组
                    </Button>
                </div>
            </div>
            <Spin spinning={loading}>
                <div className={Style.content}>
                    {data?.map(item => (
                        <ListItem data={item} key={item.taskId} />
                    ))}
                    {data?.length === 0 && (
                        <CustomEmpty className={Style.empty} />
                    )}
                </div>
            </Spin>
        </div>
    );
};

export default Index;
